import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPracticeEditRoute: InvariantJiraRoute = {
	name: 'servicedesk-practice-edit',
	path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit',
	exact: true,
	query: ['config?'],
};
